import {makeStyles, Theme} from '@material-ui/core';
import React, { cloneElement } from 'react';
import {Edit, required, SimpleForm, TextInput, Toolbar, SaveButton, DeleteButton, ReferenceInput, SelectInput} from 'react-admin';
import {Messages} from '../../consts/Messages';
import {SERVICES_CATEGORIES, SERVICES, FIXED_COLUMN_CATEGORY} from '../../consts/Names';
import {Validators} from '../../consts/Validators';
import {useParams} from "react-router-dom";

const useStyles = makeStyles((theme: Theme) => ({
   form: {
      display: 'flex',
      flexDirection: 'column'
   },

   textFld: {
      width: '300px',
      marginTop: '1em'
   },
   imageFld: {
      display: 'flex',
      width: '300px'
   },
   toolBar:{
      flex: 1,
      display: "flex",
      "justify-content": "space-between"
   },
}));


const validateStock = [required(), Validators.minValue(3, Messages.MIN_VALUE)];
const validateHair = [required(), Validators.minValue(3, Messages.MIN_VALUE)];

const NameField = ({source, record={} , label = "", children, ...props}) => {   
   let disabled = (record as any).name === FIXED_COLUMN_CATEGORY;
   let validate = (record as any).name === FIXED_COLUMN_CATEGORY ? validateHair : validateStock;
   return cloneElement( children,  {disabled, validate, source, record,   props})
}
const EditToolbar = (props) => (
   <Toolbar {...props}  className={props.className}>
      <SaveButton submitOnEnter={false} variant="text" />
      {props.record.name !== FIXED_COLUMN_CATEGORY && <DeleteButton  undoable={false}/>}      
   </Toolbar>
);

export const ServicesEdit = (props) => {
   const {theme} = props;
   let basePath
   if (typeof props.basePath === 'undefined') {
      basePath = '';
   } else {
      basePath = props.basePath
   }
   const {id} = useParams()
   const classes = useStyles(theme);
   let ids = !props.id ? id : props.id
   return (<Edit {...props} id={ids} basePath={basePath} undoable={false} title="Edit category for column" >
      <SimpleForm toolbar={<EditToolbar {...props} className={classes.toolBar}/>}>
         <NameField source={SERVICES.slug}>
            <TextInput className={classes.textFld} label="Slug" source={SERVICES.slug} />
         </NameField>

         <NameField source={SERVICES.name}>
            <TextInput className={classes.textFld} label="Name" source={SERVICES.name} />
         </NameField>
         <ReferenceInput className={classes.textFld} label="Related Service category" source={SERVICES.service_category_id} reference="services_categories" validate={[required()]}>
            <SelectInput source={SERVICES_CATEGORIES.id} />
         </ReferenceInput>
      </SimpleForm>
   </Edit>
)
}